"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UULogoLoader = function UULogoLoader(props) {
  var id = props.id,
    description = props.description,
    height = props.height,
    width = props.width,
    style = props.style;
  var icon = _constants.ICONS.IconUULogoLoader;
  var iconImage = (0, _lodash.get)(icon, 'markup', null);
  var viewBox = (0, _lodash.get)(icon, 'viewBox', null);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-uu-logo-loader",
    id: id,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    height: height,
    width: width,
    viewBox: viewBox
  }, iconImage), !(0, _lodash.isEmpty)(description) && /*#__PURE__*/_react["default"].createElement("p", {
    className: "ui-uu-logo-loader__text text-center"
  }, description));
};
UULogoLoader.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,
  /** text to appear below UULogoLoader image */
  description: _propTypes["default"].string,
  /** height of UULogoLoader image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
  */
  height: _propTypes["default"].number,
  /** width of UULogoLoader image.<br/>
   * **NOTE:** if both height and width are supplied,
   * the smaller number of the two will take precedence.
   * The image will automatically calculate aspect ratio.
  */
  width: _propTypes["default"].number,
  /** Override the inline-styles of the UULogoLoader || **Not Recommended** */
  style: _propTypes["default"].object
};
UULogoLoader.defaultProps = {
  id: '',
  description: '',
  height: null,
  width: null,
  style: {}
};
var _default = exports["default"] = UULogoLoader;